module.exports = __webpack_public_path__ + "img/wallet-charge.eb658675.svg";